import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList } from '@/js/libs/ui/src/V2';

import { LANGUAGE_KEYS } from 'src/constants';
import { LanguageTitle } from './styled';

export const LanguageDropdown = memo(function LanguageDropdown() {
  const [, i18n] = useTranslation(['backend', 'common']);

  const onChangeLanguage = useCallbackRef((key: string) => i18n.changeLanguage(key));

  return (
    <DropdownList
      minWidth={false}
      buttonComponent={
        <Button iconOnly ghost data-testid='language-button'>
          <LanguageTitle data-testid={`current-language-${i18n.language}`}>{i18n.language}</LanguageTitle>
        </Button>
      }>
      {LANGUAGE_KEYS.map((language) => (
        <DropdownList.DropdownItem
          key={language}
          disabled={language === i18n.language}
          onClick={() => onChangeLanguage(language)}
          dataTestId={`language-list-item-${language}`}>
          <LanguageTitle>{language}</LanguageTitle>
        </DropdownList.DropdownItem>
      ))}
    </DropdownList>
  );
});
